import { ReactNode } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { MBAnimationBounceIn } from '@shared/components/animation';
import { Colors, grid } from '@shared/styles';
import { MBIconV2, MBIconV2Name } from '../image/iconV2';
import { AnchoredTooltip } from '../tooltip';
import { MBTouchableOpacity } from '../touchable/opacity';

export interface RoundIconButtonProps {
  size?: number;
  icon: MBIconV2Name;
  iconSize?: number;
  color?: string;
  backgroundColor?: string;
  style?: StyleProp<ViewStyle>;
  onPress?: () => void;
  disabled?: boolean;
  tooltip: ReactNode;
}

export function RoundIconButton({
  size = grid(3),
  icon,
  iconSize = grid(2.5),
  color = Colors.v2.purple,
  backgroundColor = Colors.v2.gray05,
  onPress,
  disabled,
  tooltip,
  style,
}: RoundIconButtonProps) {
  const width = size;
  const height = size;

  return (
    <AnchoredTooltip tooltip={tooltip}>
      <MBAnimationBounceIn>
        <MBTouchableOpacity
          disabled={disabled}
          onPress={onPress}
          style={[styles.button, { backgroundColor, width, height }, style]}
        >
          <MBIconV2 name={icon} size={iconSize} color={color} />
        </MBTouchableOpacity>
      </MBAnimationBounceIn>
    </AnchoredTooltip>
  );
}

const styles = StyleSheet.create({
  button: {
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
